import {
  normalizeAiOutputFormat,
  STREET_SURVEY_DESCRIPTION_KEY,
  type AiOutputFormatSchema,
  type StreetSurveyResultFieldsDef,
} from '@citizen-walk/shared-types';

/**
 * 机上調査の結果の読み取りに使う項目 (説明文・所見) の下書き ↔ 保存値 (docs/27 §17-3、pure)。
 * '' = 引き継ぐ (地区ではテンプレートに、テンプレートでは既定に従う)。
 */
export interface StreetSurveyResultFieldsDraft {
  descriptionKey: string;
  insightKey: string;
}

export function resultFieldsDraftFromDef(
  def: StreetSurveyResultFieldsDef | null | undefined,
): StreetSurveyResultFieldsDraft {
  return { descriptionKey: def?.descriptionKey ?? '', insightKey: def?.insightKey ?? '' };
}

export function resultFieldsDefFromDraft(
  draft: StreetSurveyResultFieldsDraft,
): StreetSurveyResultFieldsDef {
  return {
    descriptionKey: draft.descriptionKey.trim() || null,
    insightKey: draft.insightKey.trim() || null,
  };
}

export interface ResultFieldOption {
  key: string;
  label: string;
}

/**
 * 選べる項目: 出力フォーマットの文字の項目 (トップレベル) と、新方式が作る説明文。
 * 新方式の説明文の key が出力フォーマットに無くても選べるようにする (新方式は常にこの key に保存する)。
 */
export function listResultFieldOptions(schema: AiOutputFormatSchema | null): ResultFieldOption[] {
  const fields = schema ? (normalizeAiOutputFormat(schema).fields ?? []) : [];
  const options: ResultFieldOption[] = fields
    .filter((f) => f.kind === 'text')
    .map((f) => ({ key: f.key, label: f.label || f.key }));
  if (!options.some((o) => o.key === STREET_SURVEY_DESCRIPTION_KEY)) {
    options.unshift({ key: STREET_SURVEY_DESCRIPTION_KEY, label: '新方式で作る地点の説明文' });
  }
  return options;
}
